module.exports = __webpack_public_path__ + "static/linguaclub-banner-3aacb3faf732512dd3711b7af29e39fa.svg";